export default {
  StatusListIncoming: [
    {name: 'Оформлена заявка', bg: 'background:rgba(45, 130, 103, 0.32);'},
    {name: 'Нет паспорта.', bg: 'background:rgba(45, 130, 103, 0.32);'},
    {
      name: 'Клиент отказался:', bg: 'background:rgba(45, 130, 103, 0.32);',
      subStatus: [
        {name: 'дорого', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'подумаю', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'обслуживание на дому', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'нужна сумма меньше 20тыс', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'нужна сумма больше 50тыс', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'узнавал условия не для себя', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'не желает диктовать ПД по телефону', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'не устраивают еженедельные платежи', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'не устраивают сроки выдачи займа', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'сейчас не нужно', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'другое', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'консультации по условиям продукта', bg: 'background:rgba(45, 130, 103, 0.32);'},
      ]
    },
    {name: 'Информация о компании.', bg: 'background: rgb(247, 190, 192);'},
    {
      name: 'Требования:', bg: 'background: rgb(247, 190, 192);',
      subStatus: [
        {name: 'гражданство', bg: 'background:rgb(247, 190, 192);'},
        {name: 'возраст', bg: 'background:rgb(247, 190, 192);'},
        {name: 'не в зоне', bg: 'background:rgb(247, 190, 192);'},
        {name: 'не прошел 1 месяц с момента отказа', bg: 'background:rgb(247, 190, 192);'},
        {name: 'нет постоянного источника дохода', bg: 'background:rgb(247, 190, 192);'},
        {name: 'нет постоянной регистрации', bg: 'background:rgb(247, 190, 192);'},
      ]
    },
    {
      name: 'Жалоба', bg: 'background: rgb(247, 190, 192);',
      subStatus: [
        {name: 'на расклейку объявлений', bg: 'background:rgb(247, 190, 192);'},
        {name: 'на смс', bg: 'background:rgb(247, 190, 192);'},
        {name: 'на автоинформатор', bg: 'background:rgb(247, 190, 192);'},
        {name: 'на звонки', bg: 'background:rgb(247, 190, 192);'}
      ]
    },
    {name: 'Сбой связи', bg: 'background: rgb(247, 190, 192);'},
    {name: 'Хулиганские действия', bg: 'background: rgb(247, 190, 192);'},
    {name: 'Ошибочно набран номер', bg: 'background: rgb(247, 190, 192);'},
    {name: 'Звонок сотрудника компании', bg: 'background: rgb(247, 190, 192);'},
    {name: 'Звонок сотруднику компании', bg: 'background: rgb(247, 190, 192);'},
    {name: 'Реклама/предложения о сотрудничестве', bg: 'background: rgb(247, 190, 192);'},
    {name: 'Звонок по услуге "Оплата частями" Кари', bg: 'background: rgb(247, 190, 192);'},
    {name: 'Прочие звонки по Кари', bg: 'background: rgb(247, 190, 192);'},
    {name: 'Другое', bg: 'background: rgb(247, 190, 192);'},
    {name: 'Обращение ДК', bg: 'background:rgba(255, 134, 63, 0.6);',
      subStatus: [
        {name: 'Статус заявки', bg: 'background:rgba(255, 134, 63, 0.6);'},
        {name: 'Сроки перечисления д/ср на счёт клиента', bg: 'background:rgba(255, 134, 63, 0.6);'},
        {name: 'Способы оплаты займа', bg: 'background:rgba(255, 134, 63, 0.6);'},
        {name: 'Агент не звонит/не приходит', bg: 'background:rgba(255, 134, 63, 0.6);'},
        {name: 'Жалоба', bg: 'background:rgba(255, 134, 63, 0.6);'},
        {name: 'Отказ от заявки', bg: 'background:rgba(255, 134, 63, 0.6);'},
        {name: 'Изменение данных в заявке', bg: 'background:rgba(255, 134, 63, 0.6);'},
        {name: 'Кредитные каникулы', bg: 'background:rgba(255, 134, 63, 0.6);'},
        {name: 'PDL', bg: 'background:rgba(255, 134, 63, 0.6);'},
        {name: 'Другое', bg: 'background:rgba(255, 134, 63, 0.6);'}
      ]
    },

  ],
  StatusListOutgoing: [
    {name: 'Оформлена заявка', bg: 'background:rgba(45, 130, 103, 0.32);'},
    {name: 'Клиент отказался', bg: 'background:rgba(45, 130, 103, 0.32);',
      subStatus: [
        {name: 'дорого', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'подумаю', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'обслуживание на дому', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'нужна сумма меньше 20тыс', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'нужна сумма больше 50тыс', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'не желает диктовать ПД по телефону', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'отказ от разговора', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'я вам сам перезвоню', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'не устраивают еженедельные платежи', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'не устраивают сроки выдачи займа', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'не нуждается в займе', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'больше не звонить', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'другое', bg: 'background:rgba(45, 130, 103, 0.32);'}
      ]
    },
    {name: 'Нет связи с клиентом', bg: 'background:rgb(247, 190, 192);',
      subStatus: [
        {name: 'нет ответа', bg: 'background:rgb(247, 190, 192);'},
        {name: 'недоступен', bg: 'background:rgb(247, 190, 192);'},
        {name: 'номер временно заблокирован', bg: 'background:rgb(247, 190, 192);'},
        {name: 'номер не существует', bg: 'background:rgb(247, 190, 192);'},
      ]
    },
    {name: 'Не соответствует требованиям', bg: 'background:rgb(247, 190, 192);',
      subStatus: [
        {name:'не в зоне', bg: 'background:rgb(247, 190, 192);'},
        {name:'гражданство', bg: 'background:rgb(247, 190, 192);'},
        {name:'возраст', bg: 'background:rgb(247, 190, 192);'},
        {name:'нет постоянного источника дохода', bg: 'background:rgb(247, 190, 192);'},
        {name:'нет постоянной регистрации', bg: 'background:rgb(247, 190, 192);'},
        {name:'уже оформил заявку ожидает рассмотрения', bg: 'background:rgb(247, 190, 192);'},
        {name:'есть активный заем в нашей компании', bg: 'background:rgb(247, 190, 192);'},
        {name:'не прошел 1 месяц с момента отказа', bg: 'background:rgb(247, 190, 192);'},
      ]
    },
    {name: 'Номер не принадлежит клиенту', bg: 'background:rgb(247, 190, 192);'},
    {name: 'Перезвонить', bg: 'background:rgba(255, 134, 63, 0.6);',
    subStatus:[
      {name:'по просьбе клиента', bg: 'background:rgba(255, 134, 63, 0.6);'},
      {name:'нет при себе паспорта', bg: 'background:rgba(255, 134, 63, 0.6);'},
      {name:'обрыв связи, перезвон через 1 час', bg: 'background:rgba(255, 134, 63, 0.6);'}
    ],
    timer:true},
  ],
  StatusListPDL: [
    {name: 'Согласен на лонгацию', bg: 'background:rgba(45, 130, 103, 0.32);'},
    {name: 'Согласен внести платеж', bg: 'background:rgba(45, 130, 103, 0.32);'},
    {name: 'Согласен на списание платежа', bg: 'background:rgba(45, 130, 103, 0.32);'},
    {name: 'Клиент отказался', bg: 'background:rgb(247, 190, 192);',
      subStatus: [
        {name: 'внесет платеж', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'отказ от лонгации', bg: 'background:rgb(247, 190, 192);'},
        {name: 'Планирует внести платеж', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'дорого', bg: 'background:rgb(247, 190, 192);'},
        {name: 'подумаю', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'отказ от разговора', bg: 'background:rgb(247, 190, 192);'},
        {name: 'я вам сам перезвоню', bg: 'background:rgb(247, 190, 192);'},
        {name: 'другое', bg: 'background:rgb(247, 190, 192);'},
      ]
    },
    {name: 'Нет связи с клиентом', bg: 'background:rgb(247, 190, 192);',
      subStatus: [
        {name: 'нет ответа', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'недоступен', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'номер временно заблокирован', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'номер не существует', bg: 'background:rgba(45, 130, 103, 0.32);'},
      ]},
    {name: 'Номер не принадлежит клиенту', bg: 'background:rgb(247, 190, 192);'},
    {name: 'Перезвонить', bg: 'background:rgba(255, 134, 63, 0.6);',
      subStatus: [
        {name: 'по просьбе клиента', bg: 'background:rgba(45, 130, 103, 0.32);'},
        {name: 'обрыв связи', bg: 'background:rgba(45, 130, 103, 0.32);'},
      ]},
      // {name: 'PDL СМС/Списание', bg: 'background:rgba(45, 130, 103, 0.32);'},
    // {name: 'Другое', bg: 'background:rgba(45, 130, 103, 0.32);'},
  ],
}
